// Helper centralizat pentru afișarea rolului utilizatorului.
// Dacă are `custom_role_label` setat de admin, îl folosim peste tot.
// Altfel, întoarcem label-ul predefinit al rolului (Manager Departament pentru admin, etc.)

export const ROLE_LABELS = {
    super_admin: "Super Admin",
    admin: "Manager Departament",
    team_lead: "Team Lead",  // legacy display, nu mai se atribuie ca rol global
    lead: "Lead",
    member: "Membru",
    viewer: "Vizualizator",
};

export function displayRole(user) {
    if (!user) return "";
    const custom = (user.custom_role_label || "").trim();
    if (custom) return custom;
    return ROLE_LABELS[user.role] || user.role || "";
}

export function hasCustomRole(user) {
    return !!(user && (user.custom_role_label || "").trim());
}
